import { AbstractView } from "../../../../../abstracts/modules/AbstractView";
import { DDDSoundNames } from "../../../../assetsLoader/DDDAssetsNames";
import { DDDFreespinOutroScreen } from "../freespin/DDDFreespinOutroScreen";

export class DDDSuperFreespinOutroScreen extends DDDFreespinOutroScreen {
    constructor(parentContainer: AbstractView) {
        super(parentContainer, `DDDSuperFreespinOutroScreen`);
    }

    protected getBackgroundMusicName(): string {
        return DDDSoundNames.SUPER_FREESPIN_MUSIC;
    }

    protected override getTweenName(): string {
        return `deaderspinoutro`;
    }

    protected override getOutroWinSoundName(): string {
        return DDDSoundNames.SFS_OUTRO_WIN;
    }
}
